module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("This edition published in Great Britain in 2021"), _c('br'), _vm._v("under license from Whittles Publishing by"), _c('br'), _vm._v("Birlinn Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("West Newington House")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10 Newington Road")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Edinburgh")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("EH9 1QS")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.birlinn.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.birlinn.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN: 978 1 78027 703 5"), _c('br'), _vm._v("ePUB ISBN: 978 1 78885 449 8")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © The estate of Mike Tomkies"), _c('br'), _vm._v("Introduction copyright © Jim Crumley 2017"), _c('br'), _vm._v("First published in 1984 by Jonathan Cape")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Subsequently published by Whittles Publishing, Dunbeath in 2017")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_c('em', [_vm._v("British Library Cataloguing-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("A catalogue record for this book is available on request from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Papers used by Birlinn are from well-managed forests and other responsible sources")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Illustration",
      "src": "images/pub.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Typeset by Hewer Text UK, Edinburgh"), _c('br'), _vm._v("Printed and bound by Clays Ltd, Elcograf S.p.A.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0